export default "__VITE_ASSET__f2XgUfvj__"